import React from "react";
import { AppRoutes } from "./pages";
import RouteTracker from "./components/RouteTracker";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";
import { ThemeProvider as StyledThemeProvider } from "@xstyled/styled-components";
import { ColorModeContext, useMode } from "./utils/theme";

const App = () => {
    const [theme, colorMode] = useMode();

    return (
        <React.StrictMode>
            <ColorModeContext.Provider value={colorMode}>
                <MuiThemeProvider theme={theme}>
                    <StyledThemeProvider theme={theme}>
                        <CssBaseline />
                        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                            <RouteTracker />
                            <AppRoutes />
                        </BrowserRouter>
                    </StyledThemeProvider>
                </MuiThemeProvider>
            </ColorModeContext.Provider>
        </React.StrictMode>
    )
}

export default App;
